import { render, staticRenderFns } from "./BasicProfile.vue?vue&type=template&id=4ceba03a&scoped=true"
import script from "./BasicProfile.vue?vue&type=script&lang=js"
export * from "./BasicProfile.vue?vue&type=script&lang=js"
import style0 from "./BasicProfile.vue?vue&type=style&index=0&id=4ceba03a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ceba03a",
  null
  
)

export default component.exports